import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {MathUtils} from '../../../../../../shared/utils/MathUtils'
import {notificationController} from '../../../EntryShared'
import {KeyBindController, ShortcutLocation} from '../../../KeyBindController'
import {audioManager, Sound} from '../../../Sound'
import {StorageWrapper} from '../../../StorageWrapper'
import {UIGameManager} from '../../UIGameManager'
import {NotificationContentType} from '../../../ui_utils/NotificationUtils'

const VOLUME_INCREMENT = 0.1
const M_KEY_EVENT_CODE = 'KeyM'
const UP_KEY_EVENT_CODE = 'ArrowUp'
const DOWN_KEY_EVENT_CODE = 'ArrowDown'
const VOLUME_TEXT = 'Volume'

export class UIGameSettingsAudioShortcuts {
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.setKeyboardShortcuts()
    }

    private setKeyboardShortcuts() {
        this.createSoundOnOffShortcut()
        this.createVolumeArrowShortcuts()
    }

    private static shouldUseAudioShortcuts(): boolean {
        return true
    }

    private createSoundOnOffShortcut() {
        KeyBindController.bindKey(M_KEY_EVENT_CODE, () => this.toggleSound(), () => UIGameSettingsAudioShortcuts.shouldUseAudioShortcuts(), ShortcutLocation.InGame)
    }

    private createVolumeArrowShortcuts() {
        const keyBindDelayInMS = 0
        KeyBindController.bindKey(UP_KEY_EVENT_CODE, () => this.updateVolumeLevel(VOLUME_INCREMENT), () => UIGameSettingsAudioShortcuts.shouldUseAudioShortcuts(), ShortcutLocation.InGame, undefined, keyBindDelayInMS)

        KeyBindController.bindKey(DOWN_KEY_EVENT_CODE, () => this.updateVolumeLevel(VOLUME_INCREMENT * -1), () => UIGameSettingsAudioShortcuts.shouldUseAudioShortcuts(), ShortcutLocation.InGame, undefined, keyBindDelayInMS)
    }

    private toggleSound() {
        audioManager.toggleMute()
        const newLevel = StorageWrapper.getMasterVolume(Sound.DEFAULT_VOLUME)
        this.uiGameManager.settingsController.gameHelpSettingsController.audio.masterAudioController.setSlider(newLevel)
        const mutedText: TranslationObject = newLevel > 0 ? {key: 'strings:game.settings.shortcutPopups.soundUnmuted'} : {key: 'strings:game.settings.shortcutPopups.soundMuted'}
        notificationController.showNotification(LobbyImage.Audio, mutedText)
    }

    private updateVolumeLevel(increment: number) {
        const currentLevel = StorageWrapper.getMasterVolume(Sound.DEFAULT_VOLUME)
        const newPercentage = currentLevel + increment
        const newVolumeLevel = MathUtils.clampBetweenZeroAndOne(newPercentage)
        if(newVolumeLevel == currentLevel) return
        Sound.setMasterVolume(newVolumeLevel)
        this.uiGameManager.settingsController.gameHelpSettingsController.audio.masterAudioController.setSlider(newVolumeLevel)
        const volumeDisplayLevel = Math.round(newVolumeLevel * 100)
        const masterVolumeChangedText: TranslationObject = {key: 'strings:game.settings.shortcutPopups.volumeLevel', options: {count: volumeDisplayLevel}}

        notificationController.showNotification(LobbyImage.Audio, masterVolumeChangedText, 2500, undefined, undefined, NotificationContentType.Volume)
    }
}
